import { initValidatedForm } from '../components/form-validation.js';

const initializedForms = new WeakMap();

(function () {
    initManualCreateForm();
    initManualEditForm();
})();

export function initManualCreateForm(documentRef = globalThis.document) {
    const form = documentRef?.querySelector?.('[data-lists-manual-create-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    initManualListTitleValidation(form);
}

export function initManualEditForm(documentRef = globalThis.document, windowRef = globalThis.window) {
    const form = documentRef?.querySelector?.('[data-lists-manual-edit-form]');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    if (initializedForms.has(form)) {
        return;
    }

    initManualListTitleValidation(form);

    // A native POST: the button locks only once a valid submit actually leaves, so a second press
    // cannot send it twice. Registered after the validation, which cancels an invalid submit first.
    const submitButton = form.querySelector('[type="submit"]');
    if (!(submitButton instanceof HTMLButtonElement)) {
        return;
    }

    form.addEventListener('submit', (event) => {
        if (!event.defaultPrevented) {
            submitButton.disabled = true;
        }
    });
    // A page restored from bfcache comes back with the lock it left with.
    windowRef?.addEventListener?.('pageshow', (event) => {
        if (event.persisted) {
            submitButton.disabled = false;
        }
    });
}

function initManualListTitleValidation(form) {
    const existingController = initializedForms.get(form);
    if (existingController !== undefined) {
        return existingController;
    }

    const titleInput = form.querySelector('input[name="title"]');
    if (!(titleInput instanceof HTMLInputElement)) {
        return;
    }

    const controller = initValidatedForm({
        form,
        fields: [
            {
                input: titleInput,
                errorContainer: titleInput.parentElement,
                errorElement: titleInput.parentElement?.querySelector?.('.lists-manual-error') ?? null,
                errorClassName: 'lists-manual-error',
                messages: {
                    valueMissing: 'Manual list title is required.',
                },
            },
        ],
    });

    if (controller !== undefined) {
        initializedForms.set(form, controller);
    }

    return controller;
}
